import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Building, User, Globe, Phone } from 'lucide-react';
import SEO from '../components/SEO';

const LegalNotices = () => {
  return (
    <div className="min-h-screen py-16">
      <SEO
        title="Mentions Légales"
        description="Mentions légales et informations réglementaires d'Eau Gratuite."
        path="/mentions-legales"
      />
      {/* Header Section */}
      <section className="py-16 bg-gradient-to-br from-sky-50 via-white to-emerald-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-sky-400 to-emerald-400 rounded-xl mx-auto mb-6">
            <Building className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Mentions Légales
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Informations légales et réglementaires d'Eau Gratuite
          </p>
          <p className="text-sm text-gray-500 mt-4">
            Dernière mise à jour : 12 septembre 2025
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            
            {/* Informations du site */}
            <Card className="p-8 border-0 shadow-lg">
              <CardContent className="p-0">
                <div className="flex items-center space-x-3 mb-6">
                  <Building className="h-6 w-6 text-sky-600" />
                  <h2 className="text-2xl font-bold text-gray-900">
                    Informations du Site
                  </h2>
                </div>
                <div className="space-y-4 text-gray-600">
                  <p><strong>Nom du site :</strong> Eau Gratuite</p>
                  <p><strong>Nature :</strong> Plateforme publicitaire innovante</p>
                  <p><strong>Email de contact :</strong> contact@eaugratuite.io</p>
                  <p><strong>Téléphone :</strong> 07 49 97 72 32</p>
                </div>
              </CardContent>
            </Card>

            {/* Hébergement */}
            <Card className="p-8 border-0 shadow-lg">
              <CardContent className="p-0">
                <div className="flex items-center space-x-3 mb-6">
                  <Globe className="h-6 w-6 text-sky-600" />
                  <h2 className="text-2xl font-bold text-gray-900">
                    Hébergement
                  </h2>
                </div>
                <div className="space-y-4 text-gray-600">
                  <div>
                    <p><strong>Hébergeur :</strong> OVH Cloud</p>
                    <p><strong>Adresse :</strong> 2 rue Kellermann<br />59100 Roubaix, France</p>
                    <p><strong>Site web :</strong> <a href="https://ovhcloud.com" className="text-sky-600 hover:text-sky-700">ovhcloud.com</a></p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Propriété intellectuelle */}
            <Card className="p-8 border-0 shadow-lg">
              <CardContent className="p-0">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Propriété Intellectuelle
                </h2>
                <div className="space-y-4 text-gray-600">
                  <p>
                    L'ensemble des éléments du site Eau Gratuite (textes, images, vidéos, design, logos) 
                    sont protégés par le droit d'auteur.
                  </p>
                  <p>
                    Toute reproduction, même partielle, sans autorisation expresse est interdite.
                  </p>
                </div>
              </CardContent>
            </Card>

            {/* Responsabilité */}
            <Card className="p-8 border-0 shadow-lg">
              <CardContent className="p-0">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Limitation de Responsabilité
                </h2>
                <div className="space-y-4 text-gray-600">
                  <p>
                    Eau Gratuite met tout en œuvre pour fournir des informations précises et à jour. 
                    Cependant, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité 
                    des informations diffusées.
                  </p>
                  <p>
                    L'utilisation des informations de ce site se fait sous la responsabilité exclusive 
                    de l'utilisateur.
                  </p>
                  <p>
                    Eau Gratuite ne saurait être tenu responsable des dommages directs ou indirects 
                    résultant de l'utilisation du site ou de l'impossibilité d'y accéder.
                  </p>
                </div>
              </CardContent>
            </Card>



            {/* Partenariat */}
            <Card className="p-8 border-0 shadow-lg">
              <CardContent className="p-0">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Partenariat Associatif
                </h2>
                <div className="space-y-4 text-gray-600">
                  <p>
                    Eau Gratuite est partenaire officiel de l'Association Ulker's, 
                    association loi 1901 d'intérêt général œuvrant pour l'accès à l'eau potable.
                  </p>
                </div>
              </CardContent>
            </Card>

            {/* Contact */}
            <Card className="p-8 border-0 shadow-lg bg-gradient-to-r from-sky-50 to-emerald-50">
              <CardContent className="p-0 text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-sky-400 to-emerald-400 rounded-lg mx-auto mb-4">
                  <Phone className="h-6 w-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Nous Contacter
                </h2>
                <div className="space-y-2 text-gray-600">
                  <p><strong>Eau Gratuite</strong></p>
                  <p>Téléphone : 07 49 97 72 32</p>
                  <p>Email : contact@eaugratuite.io</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalNotices;